<template>
  <v-app class="white">
    <v-overlay :value="getSpinner" opacity="0.8" color="white" z-index="200">
      <v-progress-circular
        indeterminate
        color="deep-purple accent-3"
        size="64"
        width="6"
      >
      </v-progress-circular>
    </v-overlay>

    <app-header @toggleDrawer="drawer = !drawer"></app-header>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      width="300"
      class="rounded-l-xl"
    >
      <app-menu @closeDrawer="drawer = false" />
    </v-navigation-drawer>

    <v-main color="white">
      <transition name="fade-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>

    <div v-if="$vuetify.breakpoint.mdAndUp" class="floating-actions">
      <v-tooltip left color="green darken-1">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            large
            color="#25D366"
            dark
            class="mb-4 elevation-4 pulse-animation"
            v-bind="attrs"
            v-on="on"
            @click="chatNow"
          >
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>
        </template>
        <span>Chat on WhatsApp</span>
      </v-tooltip>

      <v-tooltip left color="blue darken-4">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            large
            color="#00008B"
            dark
            class="elevation-4"
            v-bind="attrs"
            v-on="on"
            href="tel:+919686411733"
          >
            <v-icon>mdi-phone</v-icon>
          </v-btn>
        </template>
        <span>Book via Call</span>
      </v-tooltip>
    </div>

    <v-bottom-navigation
      v-if="$vuetify.breakpoint.smAndDown"
      app
      fixed
      grow
      color="deep-purple accent-3"
      class="glass-nav rounded-t-xl"
      height="70"
    >
      <v-btn @click="chatNow" height="100%">
        <span>WhatsApp</span>
        <v-icon color="#25D366">mdi-whatsapp</v-icon>
      </v-btn>

      <v-btn height="100%">
        <span class="font-weight-bold mt-1">Book Now</span>
        <div class="booking-fab-wrapper">
          <v-icon color="white">mdi-calendar-check</v-icon>
        </div>
      </v-btn>

      <v-btn href="tel:+919686411733" height="100%">
        <span>Call</span>
        <v-icon color="#00008B">mdi-phone-in-talk</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <app-footer class="width-100"></app-footer>
  </v-app>
</template>

<script>
import AppHeader from "@/components/Header.vue";
import AppFooter from "@/components/Footer.vue";
import AppMenu from "@/components/Menus.vue";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    AppHeader,
    AppFooter,
    AppMenu,
  },
  data() {
    return {
      drawer: false,
    };
  },
  computed: {
    ...mapGetters(["getSpinner", "isMobile"]),
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    // Scroll to top on route change
    "$route.name"(name) {
      if (name !== "HomeView") {
        this.$vuetify.goTo(0, { duration: 650, offset: 0 });
      }
    },
  },
  methods: {
    onResize() {
      this.$store.commit("setMobile", window.innerWidth < 960);
    },
    chatNow() {
      window.open(
        "https://api.whatsapp.com/send/?phone=919686411733&text=Hi%20Happy%20Harbour,%20I%20would%20like%20to%20know%20more!&type=phone_number&app_absent=0",
        "_blank"
      );
    },
    bookNow() {
      this.$router.push({ name: "BookNow" });
    },
  },
};
</script>

<style>
/* Global Font Settings */
#app {
  font-family: "DM Sans", "PT Sans", sans-serif; /* Recommended: Add DM Sans for modern feel */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Page Transition */
.fade-transition-enter-active,
.fade-transition-leave-active {
  transition: opacity 0.3s ease;
}
.fade-transition-enter,
.fade-transition-leave-to {
  opacity: 0;
}

/* Desktop Floating Actions Position */
.floating-actions {
  position: fixed;
  right: 24px;
  bottom: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
}

/* Pulse Animation for WhatsApp */
.pulse-animation {
  animation: pulse-green 2s infinite;
}

@keyframes pulse-green {
  0% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
  }
}

/* Mobile Bottom Nav Styling */
.glass-nav {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.05) !important;
  padding-bottom: env(safe-area-inset-bottom); /* iOS Safe Area */
}

/* Center 'Book' Button in Mobile Nav */
.booking-fab-wrapper {
  background: linear-gradient(45deg, #6200ea, #9575cd);
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -25px; /* Pulls it up slightly */
  box-shadow: 0 4px 10px rgba(98, 0, 234, 0.3);
}

.width-100 {
  width: 100%;
}
</style>
